type ClassInput = string | undefined | null | false;

export function cn(...inputs: ClassInput[]): string {
  return inputs.filter(Boolean).join(' ');
}
